<template>
  <div class="publisher-page">
    <!-- 1. Hero Section -->
    <section class="hero-section">
      <div class="container hero-container">
        <div class="hero-text">
          <h1>Monetize with Global AI Search Feeds</h1>
          <p>
            We provide non-branded search feeds hosted on Google/ Bing Directly,
            available for both desktop and mobile distribution. Sign up today to
            start earning revenue, or contact our team for further information.
          </p>
          <div class="hero-buttons">
            <button class="btn btn-primary" @click="openContactForm">
              Contact Us
            </button>
            <!-- <button class="btn btn-secondary" @click="openLoginForm">{{ translator('publ_hero_btn2') }}</button> -->
          </div>
        </div>
        <div class="hero-image">
          <img
            src="../../static/images/publisher/hero-illustration.png"
            alt="Monetize with AI"
          />
        </div>
      </div>
    </section>

    <!-- 2. Why Global AI Section -->
    <section class="why-section">
      <div class="container why-container">
        <div class="why-image">
          <img
            src="../../static/images/publisher/why-ai-illustration.png"
            alt="Why Global AI"
          />
        </div>
        <div class="why-text">
          <h2>Why Global AI?</h2>
          <ul class="why-list">
            <li>Search Arbitrage (AFS/RSOC) Excellence</li>
            <li>Professional and large-scale team</li>
            <li>Compliance &amp; Sustainability</li>
            <li>Big Scale &amp; Fast Increase</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 3. Features Section -->
    <section class="features-section">
      <div class="container">
        <h2>Accelerate Growth with Global AI</h2>
        <div class="features-grid">
          <div class="feature-item">
            <img
              src="../../static/images/publisher/feature-icon-1.png"
              alt="Search Feed Variety Icon"
            />
            <h3>Variety of traffic types</h3>
            <ul class="feature-list">
              <li>Social Traffic Source</li>
              <li>Native Traffic Source</li>
              <li>Other traffic types that are allowed by feed providers</li>
            </ul>
          </div>
          <div class="feature-item">
            <img
              src="../../static/images/publisher/feature-icon-2.png"
              alt="Streamlined Campaign Icon"
            />
            <h3>Fast increase &amp; scale-up spend</h3>
            <p>
              Our team ensures seamless alignment with advertisers on-boarding
              processes. Once ROAS turns positive, we will rapidly scale up
              campaigns to maximize spend and profit.
            </p>
          </div>
          <div class="feature-item">
            <img
              src="../../static/images/publisher/feature-icon-3.png"
              alt="Reporting Icon"
            />
            <h3>Compliance &amp; Sustainability</h3>
            <p>
              We ensure long-term compliance and secure advertising practices by
              combining AI-powered systems with expert manual review. This dual
              approach safeguards our partners' accounts and revenue, while
              guaranteeing that all creatives meet platform policies.
            </p>
          </div>
          <div class="feature-item">
            <img
              src="../../static/images/publisher/feature-icon-4.png"
              alt="Rapid Response Icon"
            />
            <h3>Prompt Response</h3>
            <p>
              Our committed team stands fully ready and are 24*7 online to
              support the growth and prosperity of our collaboration in the long
              run.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Partners Section -->
    <section class="partners-section">
      <div class="container">
        <h2>Our Partners</h2>
        <div class="partners-grid">
          <div class="partner-logo">
            <img src="../../static/images/Partners/ads.png" alt="ads" />
          </div>
          <div class="partner-logo">
            <img
              src="../../static/images/Partners/explorads.png"
              alt="ExplorAds"
            />
          </div>
          <div class="partner-logo">
            <img src="../../static/images/Partners/inuvo.png" alt="Inuvo" />
          </div>
          <div class="partner-logo">
            <img src="../../static/images/Partners/sedo.png" alt="sedo" />
          </div>
          <div class="partner-logo">
            <img src="../../static/images/Partners/system.png" alt="System1" />
          </div>
          <div class="partner-logo">
            <img src="../../static/images/Partners/tonic.png" alt="Tonic" />
          </div>
        </div>
      </div>
    </section>

    <!-- 4. CTA Section -->
    <!-- <section class="cta-section">
      <div class="container">
        <div class="cta-box">
          <div class="cta-image">
            <img
              src="../../static/images/publisher/cta-illustration.png"
              alt="Join as a Publisher"
            />
          </div>
          <div class="cta-text">
            <h2>Join as a Publisher Now—<br />Start Earning Today!</h2>
            <p>
              Start earning revenue in days—not weeks—with our premium search
              feeds.
            </p>
            <button class="btn btn-cta" @click="openContactForm">
              Sign Up now
            </button>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  name: "SearchArbitragePage",
  methods: {
    openContactForm() {
      this.$emit("open-form");
    },
    openLoginForm() {
      this.$emit("open-login-modal");
    },
  },
};
</script>

<style scoped>
/* General Page Styles */
.publisher-page {
  font-family: "Poppins", sans-serif;
  color: #333;
  overflow-x: hidden;

  /* --- 添加这些样式 --- */
  background-image: url("/static/images/publisher/hero-bg.jpg");
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  /* 可选：添加这个属性可以让背景在滚动时固定，有视差效果 */
  background-attachment: fixed;
  /* 设置一个基础背景色，以防图片加载失败 */
  background-color: #f0f7ff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

h1,
h2,
h3 {
  font-weight: 700;
}

p {
  line-height: 1.7;
  color: #5a6472;
}

.btn {
  padding: 14px 35px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* 1. Hero Section */
.hero-section {
  padding: 120px 0 150px;
  position: relative;

  background-color: transparent;
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.hero-text {
  flex-basis: 50%;
}

.hero-text h1 {
  font-size: 48px;
  margin-bottom: 20px;
  line-height: 1.2;
  color: #1c2b4e;
}

.hero-text p {
  font-size: 18px;
  margin-bottom: 30px;
  max-width: 500px;
}

.hero-buttons {
  display: flex;
  gap: 20px;
}

.btn-primary {
  background: linear-gradient(90deg, #4b89ff, #296dff);
  color: white;
}

.btn-secondary {
  background: linear-gradient(90deg, #30d5c8, #20c997);
  color: white;
}

.hero-image {
  flex-basis: 50%;
  text-align: right;
}

.hero-image img {
  max-width: 100%;
  height: auto;
}

/* 2. Why Section */
.why-section {
  padding: 100px 0;
}

.why-container {
  display: flex;
  align-items: center;
  gap: 60px;
}

.why-image {
  flex-basis: 45%;
}

.why-image img {
  max-width: 100%;
}

.why-text {
  flex-basis: 55%;
}

.why-text h2 {
  font-size: 40px;
  color: #1c2b4e;
  margin-bottom: 20px;
}

.why-text p {
  font-size: 16px;
}

.why-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.why-list li {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 12px;
  position: relative;
  padding-left: 20px;
}

.why-list li::before {
  content: "•";
  color: #1c2b4e;
  font-size: 1.2em;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
}

.why-list li:last-child {
  margin-bottom: 0;
}

/* 3. Features Section */
.features-section {
  padding: 100px 0;
  text-align: center;

  /* --- 添加/修改这些样式 --- */
  background-image: url("/static/images/publisher/xbj.png");
  background-size: contain; /* 让背景图铺满整个区域 */
  background-position: center; /* 背景图居中显示 */
  background-repeat: no-repeat; /* 背景图不重复 */

  /* 
       保留一个备用背景色，以防图片加载失败或加载中。
       这个颜色应该和背景图的主色调接近。
    */
  /* background-color: #f8f9fa; */

  /* 确保内容在背景图片内 */
  min-height: fit-content;
  box-sizing: border-box;
  position: relative;
}

.features-section h2 {
  font-size: 40px;
  color: #1c2b4e;
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  max-width: 100%;
  margin: 0 auto;
}

.feature-item {
  background: #fff;
  padding: 40px 20px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-item img {
  height: 60px;
  margin-bottom: 15px; /* 减少图标和标题之间的间距 */
}

.feature-item h3 {
  font-size: 20px;
  margin-bottom: 8px;
  color: #1c2b4e;
}

.feature-item p {
  font-size: 16px;
  color: #5a6472;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.feature-list li {
  font-size: 16px;
  line-height: 1.8;
  color: #5a6472;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}

.feature-list li::before {
  content: "•";
  color: #1c2b4e;
  font-size: 1.2em;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
}

.feature-list li:last-child {
  margin-bottom: 0;
}

/* Partners Section */
.partners-section {
  padding: 120px 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(240, 247, 255, 0.95) 25%,
    rgba(230, 242, 255, 0.92) 50%,
    rgba(240, 247, 255, 0.95) 75%,
    rgba(255, 255, 255, 0.98) 100%
  );
  text-align: center;
  position: relative;
  overflow: hidden;
}

.partners-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 10% 20%,
      rgba(75, 137, 255, 0.08) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 90% 80%,
      rgba(45, 109, 255, 0.08) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 50% 50%,
      rgba(100, 150, 255, 0.05) 0%,
      transparent 60%
    );
  pointer-events: none;
}

.partners-section h2 {
  font-size: 42px;
  color: #1c2b4e;
  margin-bottom: 70px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
}

.partners-section h2::after {
  content: "";
  display: block;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  margin: 20px auto 0;
  border-radius: 2px;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
  max-width: 1100px;
  margin: 0 auto;
  justify-items: center;
  position: relative;
  z-index: 1;
}

.partner-logo {
  background-color: #ffffff;
  border: 1.5px solid #e0e0e0;
  border-radius: 16px;
  padding: 30px 35px;
  width: 100%;
  max-width: 300px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.06);
}

.partner-logo::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(75, 137, 255, 0.05),
    transparent
  );
  transition: left 0.5s ease;
}

.partner-logo:hover::before {
  left: 100%;
}

.partner-logo:hover {
  transform: translateY(-8px) scale(1.02);
  border-color: #4b89ff;
  box-shadow: 0 12px 30px rgba(75, 137, 255, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #fafbff;
}

.partner-logo img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  filter: grayscale(20%);
}

.partner-logo:hover img {
  transform: scale(1.05);
  filter: grayscale(0%);
}

/* 4. CTA Section */
.cta-section {
  padding: 120px 0;
}

.cta-box {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  padding: 40px 60px;
  gap: 50px;
  overflow: hidden;
}

.cta-image {
  flex-basis: 40%;
}

.cta-image img {
  max-width: 100%;
}

.cta-text {
  flex-basis: 60%;
}

.cta-text h2 {
  font-size: 36px;
  line-height: 1.3;
  color: #1c2b4e;
  margin-bottom: 15px;
}

.cta-text p {
  font-size: 18px;
  margin-bottom: 30px;
}

.btn-cta {
  background: linear-gradient(90deg, #4b89ff, #296dff);
  color: white;
  font-size: 18px;
  padding: 18px 50px;
  border-radius: 10px;
}

/* Responsive Design */
/* 针对14英寸笔记本等中等屏幕的优化 */
@media (max-width: 1600px) {
  .features-section {
    padding: 70px 0;
  }

  .features-grid {
    gap: 25px;
  }

  .feature-item {
    padding: 30px 15px;
  }
}

@media (max-width: 1400px) {
  .features-section {
    padding: 35px 15px 25px 15px; /* 减少底部padding */
    /* 在笔记本端拉伸背景图 */
    background-size: 100% 100%;
    background-position: center center;
    min-height: auto;
  }

  .features-grid {
    gap: 15px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    max-width: 95%;
    margin: 0 auto;
  }

  .feature-item {
    padding: 18px 12px;
  }

  .feature-item img {
    margin-bottom: 12px; /* 减少图标和标题之间的间距 */
  }

  .features-section h2 {
    font-size: 32px;
    margin-bottom: 25px;
  }

  .feature-item h3 {
    font-size: 17px;
    margin-bottom: 8px;
  }

  .feature-item p,
  .feature-list li {
    font-size: 13px;
    line-height: 1.5;
  }

  .feature-list li {
    margin-bottom: 6px;
  }

  .partners-grid {
    gap: 25px;
    max-width: 900px;
  }

  .partner-logo {
    height: 130px;
    padding: 22px 28px;
    border-radius: 14px;
  }
}

@media (max-width: 992px) {
  .hero-container,
  .why-container {
    flex-direction: column;
    text-align: center;
  }

  .hero-text,
  .why-text {
    order: 2;
  }

  .hero-image,
  .why-image {
    order: 1;
    margin-bottom: 40px;
    text-align: center;
  }

  .hero-text h1 {
    font-size: 38px;
  }
  .why-text h2,
  .features-section h2,
  .partners-section h2 {
    font-size: 32px;
  }
  .hero-buttons {
    justify-content: center;
  }

  .cta-box {
    flex-direction: column;
    text-align: center;
    padding: 40px 30px;
  }

  .features-section {
    padding: 30px 15px 20px 15px; /* 减少底部padding */
    background-size: 100% 100%;
    background-position: center center;
  }

  .partners-section {
    padding: 80px 15px;
  }

  .partners-section h2 {
    font-size: 32px;
    margin-bottom: 50px;
  }

  .partners-section h2::after {
    width: 60px;
    height: 3px;
    margin: 15px auto 0;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    max-width: 600px;
  }

  .partner-logo {
    max-width: 100%;
    height: 130px;
    padding: 25px 30px;
    border-radius: 14px;
  }

  .features-grid {
    gap: 15px;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  .feature-item {
    padding: 18px 12px;
  }

  .feature-item img {
    margin-bottom: 10px; /* 减少图标和标题之间的间距 */
  }

  .feature-item h3 {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .feature-item p,
  .feature-list li {
    font-size: 12px;
    line-height: 1.5;
  }

  .feature-list li {
    margin-bottom: 5px;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .partner-logo {
    height: 110px;
    padding: 18px 20px;
  }
}

@media (max-width: 480px) {
  .partners-section {
    padding: 60px 15px;
  }

  .partners-section h2 {
    font-size: 26px;
    margin-bottom: 40px;
  }

  .partners-section h2::after {
    width: 50px;
    height: 3px;
    margin: 12px auto 0;
  }

  .partners-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 100%;
  }

  .partner-logo {
    max-width: 100%;
    height: 120px;
    padding: 20px 25px;
    border-radius: 12px;
  }

  .partner-logo:hover {
    transform: translateY(-5px) scale(1.01);
  }
}
</style>
